import { match } from 'ts-pattern';
import { Contact } from '@lgg/isomorphic/types/__generated__/graphql';

export enum ContactTextPlaceholderKey {
  firstName = 'contact_first_name',
  lastName = 'contact_last_name',
  phoneNumber = 'contact_phone_number',
  email = 'contact_email',
  fullName = 'contact_full_name',
}

export const getPresetPlaceholderValue = (key: string, contact: Contact) => {
  if (!contact) return undefined;

  return match(key)
    .with(ContactTextPlaceholderKey.firstName, () => contact.firstName)
    .with(ContactTextPlaceholderKey.lastName, () => contact.lastName)
    .with(
      ContactTextPlaceholderKey.phoneNumber,
      () => contact.primaryPhone?.national ?? contact.secondaryPhone?.national,
    )
    .with(ContactTextPlaceholderKey.email, () => contact.primaryEmail)
    .with(ContactTextPlaceholderKey.fullName, () => contact.fullName)
    .otherwise(() => undefined);
};
